
import {  userSignIn, userLogOut } from '../../redux/actions/auth'
import StepperTemplate from './StepperTemplate';
import { connect } from "react-redux";


const mapDispatchToProps = dispatch => {
    return {    
      userLoggedIn: user => {      
        dispatch(userSignIn(user));
      },
      userLogOut: () => {
        dispatch(userLogOut());
      }
    };
  };
  
  const mapStatetoProps = state => {
    return {
      user: state.user
    };
  };
  
  export default connect(
      mapStatetoProps,
      mapDispatchToProps
    )(StepperTemplate);


////export default StepperTemplate
  